import { store } from "../../..";
import { getQuestionnaireGridNavigationItem } from "../QuestionnaireGrid/utils";


export const getQuestionnaireDetailsNavigationItem = (t)=>{
   const state = store.getState();
  const questionnaireDetails = state?.questionnaireStore?.questionnaireDetails?.questionnaireDetails ;
  
    const questionnaireNavigationItems = getQuestionnaireGridNavigationItem(t)
    const isProject = questionnaireDetails?.projectId && !questionnaireDetails?.buildingId;
    const projectOrBuildingNumber  = isProject ? questionnaireDetails?.projectNo: questionnaireDetails?.buildingNoIntern;
    const breadCrumbTitle = projectOrBuildingNumber + " - " + questionnaireDetails?.name
    const to =  "/vragenlijst/"+questionnaireDetails?.id 
    return {
        breadCrumbs: [ ...questionnaireNavigationItems?.breadCrumbs , { title: t("constructionquality.questionnaire") + " - " +breadCrumbTitle, breadCrumbTitle : breadCrumbTitle , to}],
        tabs: [...questionnaireNavigationItems?.tabs ,{ title: t('general.form') , to}]
    }
}

export const getBasicDataKeys = (isProject) => {
  return [
    {
      items: [
        {
          title: isProject ? "general.projectNumber" : "general.buildingNumber",
          key: isProject ? "projectNo" : "buildingNoIntern",
          event: false,
        },
        {
          title: "general.date",
          key: "createdOn",
          event: false,
        },
      ],
    },
    {
      items: [
        {
          title: isProject ? "general.projectName" : "general.address",
          key: isProject ? "projectName" : "address",
        },
        { title: "general.status", key: "status", event: false },
      ],
    },
    {
      items: isProject
        ? [
            {
              title: "general.address.city",
              key: "projectCity",
            },
            {
              title: "",
              key: "",
              empty: true,
            },
          ]
        : [
            { title: "general.buyer1", key: "buyerRenter1" },
            { title: "general.buyer2", key: "buyerRenter2" },
          ],
    },
    {
      items: [
        { title: "general.company", key: "executorCompanyName" },
        {
          title: "general.responsible",
          key: "executor",
          event: "hover",
          showEdit: true,
        },
      ],
    },
  ];
};
